// extracted by mini-css-extract-plugin
export default {"recordBtn":"recordBtn-a4ODM8","stopBtn":"stopBtn-poXy_P","closeBtn":"closeBtn-ZJ9iXs","mask":"mask-bOtCVq","closeIcon":"closeIcon-w44kgn","btn":"btn-nnrVBE"};